import React, { PureComponent } from 'react';
import { Spin, Button } from 'antd';
import VideoPlayer from '@/components/VideoPlayer';
import classNames from 'classnames';
import { CLSTAG, videoDelayLimit } from '@/utils/constant';
import { User } from '@/redux/type';
import { request } from '@/fetch/core';
import './index.scss';
import { HttpStatusCode } from '@/fetch/core/constant';
import { clstagStr } from '@/utils/util';
import AudioRtcPlayer from '@/components/AudioRtcPlayer';
import RemoteCallModal from '@/components/RemoteCallModal';
import { Method } from '@/fetch/core/util';

interface IProps {
  license: string;
  userInfo: User | null;
  source: 'ticket' | null | undefined; // 页面来源
}
interface IState {
  isStop: boolean;
  audioStoped: boolean;
  audioRtcPlayerUrl: string | null;
  isLoading: boolean;
  loadFailed: boolean;
  loadFailedMessage: any;
  license: string;
  userInfo: User | null;
  visible: boolean;
  items: {
    direction: string;
    videoUrl: string;
  }[];
  videoListMap: any;
  directions: any[];
}
export default class Drag extends PureComponent<IProps, IState> {
  videoUrlAndDerectionMap: any = new Map([]);
  audioPlayerRef: any = React.createRef();
  constructor(props: IProps) {
    super(props);
    this.state = {
      isStop: props.source === 'ticket' ? false : true,
      audioStoped: true,
      audioRtcPlayerUrl: null,
      isLoading: false,
      loadFailed: false,
      loadFailedMessage: '',
      license: '',
      userInfo: null,
      videoListMap: new Map([]),
      visible: false,
      directions: [
        {
          text: '前',
          value: 0,
          zoomInClstag: CLSTAG.SinglePage_ZoomInFrontVideo,
          zoomOutClstag: CLSTAG.SinglePage_ZoomOutFrontVideo,
        },
        {
          text: '左',
          value: 3,
          zoomInClstag: CLSTAG.SinglePage_ZoomInLeftVideo,
          zoomOutClstag: CLSTAG.SinglePage_ZoomOutLeftVideo,
        },
        {
          text: '右',
          value: 1,
          zoomInClstag: CLSTAG.SinglePage_ZoomInRightVideo,
          zoomOutClstag: CLSTAG.SinglePage_ZoomOutRightVideo,
        },
        {
          text: '后',
          value: 2,
          zoomInClstag: CLSTAG.SinglePage_ZoomInBackVideo,
          zoomOutClstag: CLSTAG.SinglePage_ZoomOutBackVideo,
        },
      ],
      items: [],
    };
  }

  fetchVideoPlayUrl = async () => {
    const { license } = this.props;
    this.setState({
      isLoading: true,
    });
    const res: any = await request({
      path: `/monitor/web/video/url`,
      method: Method.POST,
      body: {
        vehicleName: license,
      },
    });
    const data = res?.data;
    if (res?.code != HttpStatusCode.Success) {
      const messageContent = (
        <div>
          <b style={{ fontSize: '16px', color: 'rgb(204, 255, 0)' }}>
            错误码：{res.errorCode || res.code}视频资源获取失败，请重试!
          </b>
          <div style={{ fontSize: '14px' }}>
            <div>
              data：{data === undefined ? 'undefined' : JSON.stringify(data)}
            </div>
            <div>errorMessage：{res.message}</div>
          </div>
        </div>
      );
      this.setState(() => ({
        isStop: true,
        isLoading: false,
        loadFailed: true,
        loadFailedMessage: messageContent,
      }));
    } else {
      this.videoUrlAndDerectionMap = new Map([
        ['前', data?.front],
        ['左', data?.left],
        ['右', data?.right],
        ['后', data?.back],
      ]);
      const videoUrlList: any[] = this.formatVideoList(this.state.directions);
      this.setState(() => ({
        isLoading: false,
        items: videoUrlList,
        loadFailedMessage: '',
        loadFailed: false,
        audioRtcPlayerUrl: data?.audio,
      }));
    }
  };

  formatVideoList = (directions: any[]) => {
    const videoUrlList: any = [];
    directions.forEach((item) => {
      videoUrlList.push({
        direction: item.text,
        videoUrl: this.videoUrlAndDerectionMap.get(item.text),
        zoomInClstag: item.zoomInClstag,
        zoomOutClstag: item.zoomOutClstag,
      });
    });
    return videoUrlList;
  };

  toggleVideoStopOrPlay = () => {
    if (!this.props.userInfo) {
      return;
    }
    this.setState(
      {
        isStop: !this.state.isStop,
      },
      () => {
        !this.state.isStop && this.fetchVideoPlayUrl();
      },
    );
  };

  renderContent() {
    const { isStop, isLoading, loadFailed, loadFailedMessage } = this.state;
    if (isLoading) {
      return <Spin />;
    }
    if (loadFailed) {
      return <div className='default-message'>{loadFailedMessage}</div>;
    }

    if (isStop) {
      return (
        <div className='default-message'>
          <div>
            <img
              src={require('@/assets/img/views/single/camera.png')}
              className='camera'
            ></img>
            <div className='camera-notice'>视频需要手动开启</div>
            <Button className='camera-btn' onClick={this.toggleVideoStopOrPlay}>
              开启视频
            </Button>
          </div>
        </div>
      );
    } else {
      return (
        <div className='paly-list-wrap'>
          <ul className='list'>
            {this.state.items?.map((value: any, index: number) => (
              <li className='video-item item'>
                <div className='video-wrap'>
                  {value.videoUrl ? (
                    <VideoPlayer
                      key={index + value.direction}
                      videoUrl={value.videoUrl}
                      maxDelay={videoDelayLimit}
                      direction={value.direction}
                      zoomable={true}
                      isShowOpen={true}
                      zoomInClstag={value.zoomInClstag}
                      zoomOutClstag={value.zoomOutClstag}
                    />
                  ) : (
                    <div className='no-video vcbox'>NO SIGNAL</div>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      );
    }
  }

  componentDidMount() {
    this.fetchVideoPlayUrl();
  }
  render() {
    const { isStop } = this.state;
    return (
      <div className='drag-view'>
        <div className='video-control-wrapper'>
          <div
            clstag={
              isStop ? clstagStr(CLSTAG.PlayVideo) : clstagStr(CLSTAG.StopVideo)
            }
            className={classNames('', {
              'stop-btn': !isStop,
              'play-btn': isStop,
            })}
            onClick={this.toggleVideoStopOrPlay}
          />
          <div
            className='remotecall-content'
            clstag={clstagStr(CLSTAG.RemoteCall)}
          >
            <RemoteCallModal
              vehicleName={this.props.license}
              visible={this.state.visible}
              setVisible={() => {
                this.setState({ visible: !this.state.visible });
              }}
            />
          </div>

          {this.state.audioStoped ? (
            <svg
              onClick={() => {
                this.setState({ audioStoped: false });
                this.audioPlayerRef.current.handlePlay();
              }}
              className='audio-play-btn'
              viewBox='0 0 1024 1024'
              xmlns='http://www.w3.org/2000/svg'
              width='30'
              height='30'
              clstag={clstagStr(CLSTAG.PlayAudio)}
            >
              <path
                d='M100.1 399v221c0 30.5 24.7 55.3 55.3 55.3h82.9V343.7h-82.9c-30.5 0-55.3 24.8-55.3 55.3zM803 509.5l115.3-115.3c12.4-12.4 13.6-31.5 2.6-42.5s-30-9.9-42.5 2.6L763.1 469.6 647.9 354.3c-12.4-12.5-31.5-13.6-42.5-2.6s-9.9 30 2.6 42.5l115.3 115.3L608 624.8c-12.4 12.4-13.6 31.5-2.6 42.5s30 9.9 42.5-2.6l115.3-115.3 115.3 115.3c12.4 12.4 31.5 13.6 42.5 2.6s9.9-30-2.6-42.5L803 509.5zM486.9 178L293.5 306.9v405.2L486.9 841c30.5 0 55.3-24.7 55.3-55.3V233.2c-.1-30.5-24.8-55.2-55.3-55.2z'
                fill='#0d85ff'
              />
            </svg>
          ) : (
            <svg
              onClick={() => {
                this.setState({ audioStoped: true });
                this.audioPlayerRef.current.handlePause();
              }}
              className='audio-play-btn'
              viewBox='0 0 1024 1024'
              xmlns='http://www.w3.org/2000/svg'
              width='30'
              height='30'
              clstag={clstagStr(CLSTAG.PauseAudio)}
            >
              <path
                d='M260.256 356.576l204.288-163.968a32 32 0 0 1 52.032 24.96V828a32 32 0 0 1-51.968 24.992L254.688 685.44H96a32 32 0 0 1-32-32V388.576a32 32 0 0 1 32-32h164.256zm410.528 363.552a32 32 0 0 1-44.832-45.664 214.08 214.08 0 0 0 64.32-153.312 213.92 213.92 0 0 0-55.776-144.448 32 32 0 1 1 47.36-43.04 277.92 277.92 0 0 1 72.416 187.488 278.08 278.08 0 0 1-83.488 198.976zM822.912 858.88a32 32 0 1 1-45.888-44.608A419.008 419.008 0 0 0 896 521.152c0-108.704-41.376-210.848-114.432-288.384a32 32 0 0 1 46.592-43.872C912.32 278.176 960 395.936 960 521.152c0 127.84-49.76 247.904-137.088 337.728z'
                fill='#0d85ff'
              />
            </svg>
          )}
        </div>

        {this.renderContent()}
        <AudioRtcPlayer
          url={this.state.audioRtcPlayerUrl}
          ref={this.audioPlayerRef}
        ></AudioRtcPlayer>
      </div>
    );
  }
}
